'use strict';

import Rails from '@rails/ujs';
import 'bootstrap/dist/js/bootstrap';

Rails.start();
